export default "__VITE_ASSET__e6f02657__"